import styled from 'styled-components'
import { Typography } from 'antd'

export const EditableCell = styled(Typography.Text)`
  width: 100%;
  line-height: 31px;
  margin: 0 !important;
  left: 0 !important;
`
